import t from"react";var e=t.createContext({motif:"light",isDefaultContext:!0,isCssVariableInjected:!1});export{e as default};
//# sourceMappingURL=ThemeContext.js.map
